import { forwardRef } from 'react'
import { FormField, type FormFieldProps } from '@/components/FormField'

export type RegionalDateFieldProps = Omit<FormFieldProps, 'type' | 'control' | 'children'>

export const RegionalDateField = forwardRef<HTMLInputElement, RegionalDateFieldProps>(
  function RegionalDateField(props, ref) {
    return <FormField ref={ref} type="date" {...props} />
  },
)
